import React, { useEffect } from 'react'
import { useServices, useFetchPreludeData } from 'cng-web-lib'
import IntegrationRedirectApiUrls from 'src/apiUrls/IntegrationRedirectApiUrls'
import { useHistory } from 'react-router-dom'

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

function IntegrationRedirect() {
    const { securedSendRequest } = useServices()
    const history = useHistory()
    const fetchPreludeData = useFetchPreludeData()

    async function exchangeToken() {
        const params = new URLSearchParams(window.location.search)
        const authorizationCode = params.get("authorizationCode")

        if (authorizationCode !== "" && authorizationCode !== undefined) {
            const formData = new FormData()
            formData.append("authorizationCode", authorizationCode)

            securedSendRequest.execute(
                'POST',
                IntegrationRedirectApiUrls.TOKEN_EXCHANGE,
                formData,
                async (response) => {
                    if (response.status === 200 && response.data) {
                        const token = response.data.authToken
                        if (token != null) {
                            console.log("Storing token to local storage")
                            localStorage.setItem("userToken", JSON.stringify(token))
                        }
                    }

                    await retryFetchPreludeData(5, 300)
                },
                (error) => {
                    history.push('/login')
                }
            )
        }
    }

    function fetchPreludeDataAsync() {
        return new Promise((resolve, reject) => {
            fetchPreludeData(
                (userPreference) => resolve(userPreference),
                () => {},
                () => console.log('Fetch form config failed.'),
                () => console.log('Fetch privileges failed.'),
                (error) => {
                    if (error?.response?.status !== 404) {
                        console.log('Fetch user preference failed.')
                    }
                    reject(error)
                },
                () => console.log('Fetch system config failed.'),
                () => console.log('Fetch white label failed.')
            )
        })
    }

    async function callFetchPreludeData() {
        const userToken = localStorage.getItem("userToken")
        if (!userToken || userToken === "null") {
            throw new Error("Missing user token")
        }

        await sleep(300)

        const userPreference = await fetchPreludeDataAsync()

        history.push(userPreference.homePage)
        return true
    }

    async function retryFetchPreludeData(maxTries = 5, delayMs = 1000) {
        for (let tryCount = 1; tryCount <= maxTries; tryCount++) {
            try {
                console.log("try count: " + tryCount)
                await callFetchPreludeData()
                return
            } catch (e) {
                if (tryCount === maxTries) {
                    history.push('/login')
                    return
                }

                await sleep(delayMs)
            }
        }
    }

    function clearInvalidLocalStorage() {
        const userToken = localStorage.getItem("userToken")
        if (
            userToken == null ||
            userToken == "null" ||
            userToken == undefined ||
            userToken == ""
        ) {
            localStorage.clear()
        }
    }

    useEffect(() => {
        clearInvalidLocalStorage()
        exchangeToken()
    }, [])

    return "Redirecting..."
}

export default IntegrationRedirect